module.exports = __webpack_public_path__ + "media/images/logos/logo-knowledge-d1d1be8175228fc7d5c8b9742b0fb516.svg";